import { IPartnerFinSobRow } from '../../model/types'

import { OVERALL_CATEGORY } from './constants'
import { isRequestedCategoryRow } from './isRequestedCategoryRow'
import { TCategoryRowScope } from './types'

interface IParams {
  rows: IPartnerFinSobRow[]
  selectedFYear: number
  category?: string
  categoryRowScope?: TCategoryRowScope
}

export const getBaselineRows = ({
  rows,
  selectedFYear,
  category = OVERALL_CATEGORY,
  categoryRowScope = 'total',
}: IParams): IPartnerFinSobRow[] => {
  const baselineFYear = selectedFYear - 1 // previous year
  return rows.filter(
    (row) => row.fYear === baselineFYear && isRequestedCategoryRow(row, category, categoryRowScope)
  )
}
